/**
 * Data every page reads (subjects, products) that the dashboard-api only
 * serves to a signed-in admin.
 *
 * App.vue used to fetch these once, when the app mounted. That works only
 * while Firebase already holds a session at mount time. After "Switch region",
 * the moved-school sign-out, or a first sign-in in a new browser, the app
 * mounts on the login page with nobody signed in and storage purged: the fetch
 * is refused, the persisted stores stay empty, and nothing fetches again after
 * login, so the Add School subject list is empty (NLM-Test #217). So load on
 * every sign-in instead, once per admin per page load.
 */

import type { Auth, User } from "firebase/auth";
import { onAuthStateChanged } from "firebase/auth";

export function loadOnSignIn(auth: Auth, load: (user: User) => Promise<void>): () => void {
  let loadedFor: string | null = null;
  return onAuthStateChanged(auth, user => {
    if (!user) {
      // Signed out: the next admin to sign in gets a fresh load.
      loadedFor = null;
      return;
    }
    if (loadedFor === user.uid) return;
    loadedFor = user.uid;
    load(user).catch(() => {
      // Let the next sign-in try again rather than leave the stores empty for good.
      loadedFor = null;
    });
  });
}
